var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE1HouseZonesChoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 55V28.42L21.16 14 0 29.11V59h75.94v-4H42zm-4-15H23v15h-4V40H4v-4h15V21h4v15h15v4z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E1_House_zones_choice.daffdaff.svg";
export { SvgE1HouseZonesChoice as ReactComponent };